/// <reference path="../../../../../rcwebmodels/reeferformatter.cs.d.ts" />
/// <reference path="../../../../../rcwebmodels/gensetstatus.cs.d.ts" />
import * as React from 'react';
import $ from 'jquery';
import DatePicker from 'react-datepicker';
import moment, { max } from 'moment';
import DateFormat from 'dateformat';
//import { DateTime } from 'react-datetime-bootstrap';
import Formatters from '../../actions/Formatters';
import { RCUtils } from './../../RCUtils';
import { PopupWindow } from '../sharedcomponents/PopupWindow';
import * as Highcharts from 'highcharts';
import HC_Exporting from 'highcharts/modules/exporting';
var Config: any = require('../../Config.json');

interface GensetGraphState {
    graphData: server.GensetHistoryUI[];
    Filters: GensetHistoryFilter;
    PreferenceDTTM: any;
    buttonState: boolean;
}

var self;

export class GensetMonitorGraph extends React.Component<any, GensetGraphState> {
    chartGensetMonitor: Highcharts.ChartObject;
    constructor(props: any) {
        super(props);
        HC_Exporting(Highcharts);
        var currentUtcDttm = moment(new Date(new Date().toUTCString()).toISOString(), 'YYYY-MM-DDTHH:mm:ss');
        var filterSet = this.initHistoryFilters();//new GensetHistoryFilter();
        
        if (this.props.gensetHistoryFilters != null && this.props.gensetHistoryFilters != undefined) {
            filterSet.FromDate = this.props.gensetHistoryFilters.FromDate;
            filterSet.ToDate = this.props.gensetHistoryFilters.ToDate;
            filterSet.AssetNumber = this.props.gensetHistoryFilters.AssetNumber;
            filterSet.DeviceNumber = this.props.gensetHistoryFilters.DeviceNumber;

            this.setState({ Filters: filterSet });
        }
        this.state = {
            Filters: filterSet,
            graphData: this.props.gensetHistoryData,
            PreferenceDTTM: Formatters.DateTimeFormatter(currentUtcDttm),
            buttonState: false
        };

        self = this;
    }
    
    initHistoryFilters() {
        var gensetHistoryFilter = new GensetHistoryFilter();
        gensetHistoryFilter.AssetNumber = '';
        gensetHistoryFilter.DeviceNumber = '';
        gensetHistoryFilter.FromDate = DateFormat(new Date(), 'mm/dd/yyyy HH:MM');
        gensetHistoryFilter.ToDate = DateFormat(new Date(), 'mm/dd/yyyy HH:MM');
        gensetHistoryFilter.EventCode = '';

        return gensetHistoryFilter;
    }

    componentDidMount() {
        this.renderDateFields();
        this.BindGraphData();
    }

    componentWillReceiveProps(nextProps: any) {
        this.setState({
            graphData: nextProps.gensetHistoryData,
            Filters: nextProps.gensetHistoryFilters
        }, () => this.refreshGraphPoints());
    }

    refreshGraphPoints() {
        this.renderDateFields();
        this.updateGraphData();
    }

    renderDateFields() {
        var currentDateFilters = this.state.Filters;

        if (this.state.graphData != null && this.state.graphData != undefined && this.state.graphData.length > 0) {
            var graphTimes: any[] = this.state.graphData.map(x => new Date(x.EventDTTM));
            var graphSortedTimes = graphTimes.sort(function (a, b) { return b.getTime() - a.getTime() });
            var toDTTM = Formatters.DateTimeFormatter(graphSortedTimes[0]);
            var fromDTTM = Formatters.DateTimeFormatter(graphSortedTimes[graphSortedTimes.length - 1]);
            var toDate = moment(new Date(toDTTM)).endOf('day').toString();
            var fromDate = moment(new Date(fromDTTM)).startOf('day').toString();
            currentDateFilters.FromDate = DateFormat(new Date(fromDate), 'mm/dd/yyyy HH:MM');
            currentDateFilters.ToDate = DateFormat(new Date(toDate), 'mm/dd/yyyy HH:MM');
            this.setState({ Filters: currentDateFilters });
        }
        else {
            var toDTTM = DateFormat(new Date(Date.now()), 'mm/dd/yyyy');
            var modifiedDttm = new Date(Date.now());
            modifiedDttm.setDate(modifiedDttm.getDate() - 1);
            var fromDTTM = DateFormat(new Date(modifiedDttm), 'mm/dd/yyyy');
            var fromDate = moment(new Date(fromDTTM)).startOf('day').toString();
            var toDate = moment(new Date(toDTTM)).endOf('day').toString();
            currentDateFilters.FromDate = DateFormat(new Date(fromDate), 'mm/dd/yyyy HH:MM');
            currentDateFilters.ToDate = DateFormat(new Date(toDate), 'mm/dd/yyyy HH:MM');
            this.setState({ Filters: currentDateFilters });
        }
    }

    fromDateChange(date) {
        var filters = self.state.Filters;
        filters.FromDate = DateFormat(new Date(date), 'mm/dd/yyyy HH:MM');
        self.setState({ Filters: filters, buttonState: true });
        //$('#btnReeferHistorySearch').removeAttr('disabled');
    }

    toDateChange(date) {
        var filters = self.state.Filters;
        filters.ToDate = DateFormat(new Date(date), 'mm/dd/yyyy HH:MM');
        self.setState({ Filters: filters, buttonState: true });
    }

    enableDisableSearchButton(isEnable: any) {
        if (isEnable) {
            this.setState({ buttonState: true });
        }
        else {
            this.setState({ buttonState: false });
        }
    }

    ValidateHistoryDates(filters: any) {
        var currentUtcDttm = moment(new Date(new Date().toUTCString()).toISOString(), 'YYYY-MM-DDTHH:mm:ss');
        var currentDttm = Formatters.DateTimeFormatter(currentUtcDttm);
        this.setState({ PreferenceDTTM: currentDttm });
        //var currentDttm = this.state.PreferenceDTTM;
        var fromDttm = filters.FromDate;
        var toDttm = filters.ToDate;
        if (fromDttm == "Invalid date" || fromDttm == null || fromDttm == "")
            return "Invalid From Date.";

        if (toDttm == "Invalid date" || toDttm == null || toDttm == "")
            return "Invalid To Date.";

        if (moment(new Date(fromDttm)) > moment(new Date(currentDttm)).endOf('day'))
            return "From date should not be greater than current date.";

        if (moment(new Date(toDttm)) > moment(new Date(currentDttm)).endOf('day'))
            return "To date should not be greater than current date.";

        if (moment(new Date(fromDttm)) > moment(new Date(toDttm)))
            return "From Date should not be greater than To Date.";

        return "";
    }

    getGensetHistoryDetails() {
        $('#globalLoader').show();
        var filters = this.state.Filters;
        var message = this.ValidateHistoryDates(filters);
        if (message != "") {
            PopupWindow.showErrorMessage("Alert", message);
            $('#globalLoader').hide();
            return;
        }
        else {
            this.setState({ Filters: filters });
        }
        
        var fromDate = moment(new Date(filters.FromDate)).toString();
        var toDate = moment(new Date(filters.ToDate)).toString();
        filters.FromDate = DateFormat(new Date(fromDate), 'mm/dd/yyyy HH:MM');
        filters.ToDate = DateFormat(new Date(toDate), 'mm/dd/yyyy HH:MM');
        var filterParams = JSON.stringify(filters);
        var request = RCUtils.FetchRequest(Config.ApiBaseUrl + '/api/Asset/GensetHistoryDataSP', { method: 'POST', body: filterParams, headers: { 'Accept': 'application/json', 'Content-Type': 'application/json' } });
        fetch(request)
            .then(RCUtils.handleError)
            .then(response => response.json() as Promise<server.GensetHistoryUI[]>)
            .then(data => {
                this.setState({
                    graphData: data
                }, () => this.updateGraphData());
            });
    }

    dateTimeFormatter(dateTimeVal: any) {
        if (dateTimeVal != null && dateTimeVal != undefined) {
            var timeZoneOffset = JSON.parse(sessionStorage.getItem('UserInfo')).TimeZoneOffSet;
            var eventdttm = new Date(dateTimeVal.toString());
            var prefDateTime = new Date(eventdttm.getTime() + (parseInt(timeZoneOffset) * 60000));
            return prefDateTime.getTime();
        }
        else {
            return null;
        }
    }

    getSeriesDataForFuelLevel(currentData: any[], seriesName: string, axesNo: number) {
        if (currentData.length > 0) {
            var returnSeriesData = [];
            $.each(currentData, function (i, val) {
                if (val.Qualifier != null && ((val.Qualifier == 'A') || (val.Qualifier == 'P'))) {
                    if (val.Value != null && val.Value != undefined) {
                        if (axesNo == 1) {
                            var floatVal = Formatters.FloatFormatterForGraph(val.Value);
                            if (floatVal != 'OOR' && floatVal != '-NA-') {
                                returnSeriesData.push(floatVal);
                            }
                            else {
                                returnSeriesData.push(null);
                            }
                        }
                    }
                }                
                else {
                    returnSeriesData.push(null);
                }
            });
        }

        var voltageSeries;
        if (axesNo == 1) {
            voltageSeries = {
                name: seriesName,
                type: 'spline',
                data: returnSeriesData,
                yAxis: axesNo
            };
        }

        return voltageSeries;
    }

    getSeriesData(currentData: any[], seriesName: string, axesNo: number) {
        
        if (currentData.length > 0) {
            var returnSeriesData = [];
            $.each(currentData, function (i, val) {
                if (val.Value != null && val.Value != undefined) {
                    if (axesNo == 1) {
                        if (val.Value != undefined && val.Value != null) {
                            returnSeriesData.push(val.Value);
                        }
                        else {
                            returnSeriesData.push(null);
                        }
                    }
                    else {
                        var floatVal = Formatters.FloatFormatterForGraph(val.Value);
                        if (floatVal != 'OOR' && floatVal != '-NA-') {
                            returnSeriesData.push(floatVal);
                        }
                        else {
                            returnSeriesData.push(null);
                        }
                    }
                }
                else {
                    returnSeriesData.push(null);
                }
            });
        }

        var voltageSeries;
        if (axesNo == 1) {
            voltageSeries = {
                name: seriesName,
                type: 'spline',
                data: returnSeriesData,
                yAxis: axesNo
            };
        }
        else {
            voltageSeries = {
                name: seriesName,
                type: 'spline',
                data: returnSeriesData
            };
        }

        return voltageSeries;
    }

    GraphPoints() {
        var gensetBatteryVoltage = [];
        var deviceBatteryVoltage = [];
        var gensetFuelLevel = [];

        var gensetIdSelected = this.state.graphData[0].AssetNumber;
        var graphTimes = this.state.graphData.map(x => x.EventDTTM);
        var xAxisCategories = [];
        var xAxisPlotValues = [];
        var GensetRunStateValues = [];
        GensetRunStateValues = this.state.graphData.map(x => ({
            EventDTTM: x.EventDTTM,
            IgnitionOn: x.IgnitionOn
        }));
        GensetRunStateValues = GensetRunStateValues.sort(x => x.EventDTTM).reverse();
        // declare some variables prepare plot bands 
        var plotBandsArray: any[] = [];
        try {
            var m = 0;
            var n = 0;
            var e = 0;
            var f = 0;
            var allPow = 0;
            var max = GensetRunStateValues.length - 1;
            // prepare a plotband array like [start position of IgnitionOn=0 or false(index),end position of IgnitionOn=0 or false(index)] like [[2,6],[11,14],[18,20]]
            for (var i = 0; i < GensetRunStateValues.length; i++) {
                if (GensetRunStateValues[i].IgnitionOn == 1 || GensetRunStateValues[i].IgnitionOn == true) {
                    m = i;
                    for (var j = i; j < GensetRunStateValues.length; j++) {
                        if (GensetRunStateValues[j].IgnitionOn == 0 || GensetRunStateValues[j].IgnitionOn == false) {
                            n = j;
                            i = j;
                            if (GensetRunStateValues[j].IgnitionOn != null) {
                                plotBandsArray.push([m, n])
                            }
                            break;
                        }
                    }

                }
            }
            // find  IgnitionOff exists before IgnitionOn occurs from last
            for (var g = max; g >= 0; g--) {
                if (GensetRunStateValues[g].IgnitionOn != null) {
                    if (GensetRunStateValues[g].IgnitionOn == 1 || GensetRunStateValues[g].IgnitionOn == true) {
                        e = g;
                        break;
                    }
                }

            }
            // find IgnitionOn exists before IgnitionOff occurs from last and find there is No IgnitionOn exists
            for (var h = max; h >= 0; h--) {
                if (GensetRunStateValues[h].IgnitionOn != null) {
                    if (GensetRunStateValues[h].IgnitionOn == 0 || GensetRunStateValues[h].IgnitionOn == false) {
                        f = h;
                        allPow = 1;
                        break;
                    }
                }

            }
            //if IgnitionOff exists before IgnitionOn means last point will be [Bindex,last point of array]
            // if all IgnitionOn total graph ploted with band
            var p,cnt = 0;
            if (e > f) {
                if (e != GensetRunStateValues.length) {
                    if (allPow == 1) {
                        for (var k = h; k < GensetRunStateValues.length; k++) {
                            if (GensetRunStateValues[k].IgnitionOn != null) {
                                if (GensetRunStateValues[k].IgnitionOn == 1 || GensetRunStateValues[k].IgnitionOn == true) {
                                    p = k;
                                    for (var l = k; l < GensetRunStateValues.length; l++) {
                                        if (GensetRunStateValues[l].IgnitionOn == 1 || GensetRunStateValues[l].IgnitionOn == true) {
                                            cnt = cnt + 1;
                                        }
                                    }
                                    plotBandsArray.push([p,p+cnt])
                                    break;
                                }
                            }
                        }
                    } else {
                        plotBandsArray.push([f, max])
                    }
                }
            }

            var i = 0;
 
            while (i < plotBandsArray.length) {
                var plotBandObject = {
                    color: '#ececeb',
                    from: plotBandsArray[i][0],
                    to: plotBandsArray[i][1],
                    id: 'gensetRunningGraphPlot1',
                    label: {
                        text: 'Switch On',
                        y: 50,
                        rotation: 90,
                        align: 'center'
                    }
                };
                xAxisPlotValues.push(plotBandObject);
                i += 1;
            }
        } catch (Error) {
            // ignore errors during prepare a plotband array 
            //PopupWindow.showErrorMessage("Alert", Error.message);
        }


        $.each(graphTimes, function (i, val) {
            xAxisCategories.push(self.dateTimeFormatter(val));
        });

        xAxisCategories.sort();

        // Y1-axis Data
        gensetBatteryVoltage = this.state.graphData.map(x => ({
            EventDTTM: x.EventDTTM,
            Value: x.ExtBattVoltage
        }));
        gensetBatteryVoltage = gensetBatteryVoltage.sort(x => x.EventDTTM).reverse();
        var returnGensetBatterySeries = this.getSeriesData(gensetBatteryVoltage, 'Genset bat (V)', 2);
        returnGensetBatterySeries.color = "#EC7063";

        deviceBatteryVoltage = this.state.graphData.map(x => ({
            EventDTTM: x.EventDTTM,
            Value: x.BattVoltage
        }));
        deviceBatteryVoltage = deviceBatteryVoltage.sort(x => x.EventDTTM).reverse();
        var deviceBatteryVoltageSeries = this.getSeriesData(deviceBatteryVoltage, 'Device bat (V)', 2);
        deviceBatteryVoltageSeries.color = "#F1C40F";

        gensetFuelLevel = this.state.graphData.map(x => ({
            EventDTTM: x.EventDTTM,
            Value: x.FuelLevel != null ? parseFloat(x.FuelLevel.toString()).toFixed(2) : null,
            Qualifier: x.FuelLevelQualifier
        }));
        gensetFuelLevel = gensetFuelLevel.sort(x => x.EventDTTM).reverse();
        var gensetFuelLevelSeries = this.getSeriesDataForFuelLevel(gensetFuelLevel, 'Fuel (gal)', 1);
        gensetFuelLevelSeries.color = "#27AE60";
                
        var dataObject = {
            gensetId: gensetIdSelected,
            xAxisData: xAxisCategories,
            xAxisPlotData: xAxisPlotValues,
            yAxisData: [returnGensetBatterySeries, deviceBatteryVoltageSeries, gensetFuelLevelSeries]
        }

        return dataObject;
    }

    updateGraphData() {
        if (this.chartGensetMonitor != undefined && this.chartGensetMonitor != null
            && this.chartGensetMonitor.series != undefined && this.chartGensetMonitor.series[0] != undefined) {
            if (this.state.graphData.length > 0) {
                var graphCurrentData = this.GraphPoints();
                this.chartGensetMonitor.xAxis[0].removePlotBand('gensetRunningGraphPlot1');
                if (graphCurrentData.xAxisPlotData != null && graphCurrentData.xAxisPlotData.length > 0) {                    
                    $.each(graphCurrentData.xAxisPlotData, function (i, val) {
                        self.chartGensetMonitor.xAxis[0].addPlotBand(val);
                    });
                }
                this.chartGensetMonitor.xAxis[0].setCategories(graphCurrentData.xAxisData);
                this.chartGensetMonitor.series[0].setData(graphCurrentData.yAxisData[0].data);
                this.chartGensetMonitor.series[1].setData(graphCurrentData.yAxisData[1].data);
                this.chartGensetMonitor.series[2].setData(graphCurrentData.yAxisData[2].data);
                this.chartGensetMonitor.redraw();
                $('.highcharts-reset-zoom').click();
                if (graphCurrentData.yAxisData[0].data.length == 0 && graphCurrentData.yAxisData[1].data.length == 0
                    && graphCurrentData.yAxisData[2].data.length == 0) {
                    $('#divMessageBox').show();
                }
                else {
                    $('#divMessageBox').hide();
                }
            }
            else {
                this.chartGensetMonitor.xAxis[0].setCategories([]);
                this.chartGensetMonitor.series[0].setData([]);
                this.chartGensetMonitor.series[1].setData([]);
                this.chartGensetMonitor.series[2].setData([]);               
                this.chartGensetMonitor.redraw();
                $('#divMessageBox').show();
                $('.highcharts-reset-zoom').click();
            }
        }

        $('#globalLoader').hide();
    }

    BindGraphData() {
        if (this.state.graphData != null && this.state.graphData.length > 0) {
            var parent = this;
            var element = document.getElementById('gensetMonitorGraphDiv');

            var tooltipOption: Highcharts.TooltipOptions = {
                shared: true,
                useHTML: true,
                headerFormat: '<small>{point.key:%m-%e-%y %H:%M}</small><table>',
                pointFormat: '<tr><td style="color: {series.color}">{series.name}: </td>' +
                    '<td style="text-align: right"><b>{point.y}</b></td></tr>',
                footerFormat: '</table>',
            }
            
            var isChrome = /Chrome/.test(navigator.userAgent) && /Google Inc/.test(navigator.vendor);
            if (typeof (element) != 'undefined' && element != null) {
                if (isChrome) {
                    Highcharts.setOptions({
                        global: {
                            useUTC: false
                        },
                        exporting: {
                            buttons: {
                                contextButton: {
                                    menuItems: Highcharts.getOptions().exporting.buttons.contextButton.menuItems.splice(2)
                                }
                            }
                        }
                    });
                }
                else {
                    Highcharts.setOptions({
                        global: {
                            useUTC: false
                        }
                    });
                }

                var graphCurrentData = this.GraphPoints();
                if (graphCurrentData.yAxisData[0].data.length == 0 && graphCurrentData.yAxisData[1].data.length == 0
                    && graphCurrentData.yAxisData[2].data.length == 0) {
                    $('#divMessageBox').show();
                }
                else {
                    $('#divMessageBox').hide();
                }

                parent.chartGensetMonitor = Highcharts.chart('gensetMonitorGraphDiv', {
                    chart: {
                        zoomType: 'xy'
                    },
                    title: {
                        text: 'Genset Monitoring Data: ' + graphCurrentData.gensetId
                        //text: ''
                    },
                    xAxis: [{
                        type: 'dateTime',
                        categories: graphCurrentData.xAxisData,
                        labels: {
                            format: '{value:%m-%e-%y %H:%M}'
                        },
                        plotBands: graphCurrentData.xAxisPlotData
                    }],
                    exporting: {
                        enabled: true,
                        sourceWidth: 1600,
                        sourceHeight: 500,
                        buttons: {
                            contextButton: {
                                align: 'right',
                                x: 0,
                                y: 50,
                                verticalAlign: 'top'
                            }
                        },
                        chartOptions: {
                            plotOptions: {
                                series: {
                                    dataLabels: {
                                        enabled: true
                                    }
                                }
                            }
                        }
                    },
                    yAxis: [{ // Primary yAxis
                        labels: {
                            //format: '{value} (V)',  
                            formatter: function () {
                                return this.value;
                            },
                            style: {
                                color: "#388E3C"
                            }
                        },
                        title: {
                            text: 'Voltage (V)',
                            style: {
                                color: "#388E3C"
                            }
                        }
                    }, { // Secondary yAxis
                        gridLineWidth: 0,
                        title: {
                            text: 'Gallons (gal)',
                            style: {
                                color: Highcharts.getOptions().colors[0]
                            }
                        },
                        labels: {
                            //format: '{value} (Gal)',
                            formatter: function () {
                                return this.value;
                            },
                            style: {
                                color: Highcharts.getOptions().colors[0]
                            }
                        },
                        opposite: true
                    }],
                    plotOptions: {
                        spline: {
                            marker: {
                                enabled: true
                            }
                        },
                        series: {
                            connectNulls: true
                        }
                    },
                    tooltip: tooltipOption,
                    legend: {
                        layout: 'vertical',
                        align: 'right',
                        verticalAlign: 'middle',
                        floating: false,
                        backgroundColor: 'rgba(255,255,255,0.25)'
                    },
                    series: graphCurrentData.yAxisData
                });
            }
        }
    }

    public render() {
        return <div>
            <div className="TemperatureSearch">                
                <div className="input-group from-to-calender">
                    <span className="input-group-text">From</span>
                        <DatePicker
		                    selected={new Date(this.state.Filters.FromDate)}
		                    maxDate={new Date(this.state.PreferenceDTTM)}
		                    onChange={this.fromDateChange.bind(this)}
		                    timeInputLabel="Time:"
                            showYearDropdown
                            yearDropdownItemNumber={5}
		                    dateFormat="MM/dd/yyyy hh:mm aa"
		                    showTimeInput  
		                    className=""                          
	                    />                        
                  
              
                    <span className="input-group-text">To</span>
            
              
                  
                        <DatePicker
		                    selected={new Date(this.state.Filters.ToDate)}
		                    maxDate={new Date(this.state.PreferenceDTTM)}
		                    onChange={this.toDateChange.bind(this)}
		                    timeInputLabel="Time:"
                            showYearDropdown
                            yearDropdownItemNumber={5}
		                    dateFormat="MM/dd/yyyy hh:mm aa"
		                    showTimeInput
		                    className=""    
	                    />
                   
              
                    {
                        this.state.buttonState == true ?
                            <button type='button' onClick={this.getGensetHistoryDetails.bind(this)} className='btn btn-primary float-start'>Search</button>
                            :
                            <button type='button' disabled={this.state.buttonState == false} className='btn btn-primary float-start'>Search</button>
                    }
                </div>
            </div>
            <div id="divMessageBox" className='alert alert-danger alert-temp'>No Data Available</div>
            <div id="gensetMonitorGraphDiv"></div>
        </div>
    }
}

class GensetHistoryFilter {
    AssetNumber: string;
    DeviceNumber: string;
    FromDate: string;
    ToDate: string;
    EventCode: string;
}

